/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

const getBrowser = function() {
  const ua = navigator.userAgent;
  let tem = undefined;
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return 'IE ' + (tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR\/(\d+)/);
    if (tem !== null) {
      return 'Opera ' + tem[1];
    }
  }
  M = M[2] ? [
    M[1],
    M[2]
  ] : [
    navigator.appName,
    navigator.appVersion,
    '-?'
  ];
  if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
    M.splice(1, 1, tem[1]);
  }
  return M[0];
};

const getBrowserVersion = function() {
  const ua = navigator.userAgent;
  let tem = undefined;
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return 'IE ' + (tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR\/(\d+)/);
    if (tem !== null) {
      return 'Opera ' + tem[1];
    }
  }
  M = M[2] ? [
    M[1],
    M[2]
  ] : [
    navigator.appName,
    navigator.appVersion,
    '-?'
  ];
  if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
    M.splice(1, 1, tem[1]);
  }
  return M[1];
};

root.initFeedbackForm = function() {
  const form = $('form.new_feedback');
  form.find('#feedback_agent').val(navigator.userAgent);
  return form.find('#feedback_browser').val(getBrowser() + ' ' + getBrowserVersion());
};

/*
$(function() {
  if ($('.new_feedback').length) {
    return initFeedbackForm();
  }
});
*/

function initFeedbackFormOnLoad() {
  if ($('.new_feedback').length) {
    initFeedbackForm();
  }
}

$(initFeedbackFormOnLoad);
document.addEventListener('turbo:load', initFeedbackFormOnLoad);
